import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';
import { DateTime } from 'luxon';
import { Utilities } from 'src/app/core/helper/util';


@Component({
  selector: 'app-datetime-input',
  templateUrl: './datetime-input.component.html',
  styleUrls: ['./datetime-input.component.scss', '../form-inputs-style.scss'],
  providers: [MakeProvider(DateTimeInputComponent)]
})
export class DateTimeInputComponent extends InputComponent implements OnInit, OnChanges {


  @Input() type = 'datetime';
  @Input() timeAnchor: TimeAnchor = TimeAnchor.Now;
  @Input() minTime?: string;
  @Input() minDate: string = DateTime.local().minus({ years: 5 }).toISO();
  @Input() maxDate: string = DateTime.local().plus({ years: 10 }).toISO();
  @Input() minuteStep?: number;


  inputTime?: string;
  inputDate?: string;
  minuteOptions: number[];
  dateInputId: string = Utilities.getRandomString(10);
  timeInputId: string = Utilities.getRandomString(10);


  constructor() { super(); }

  ngOnInit() {
    setTimeout(() => {
      this.initDateTimeValues();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Log.debug('datetime ngOnChanges: ', changes);
    this.initDateTimeValues();

    this.minuteOptions = this.generateMinuteOptions();
  }

  clear() {
    this.value = undefined;
    this.inputDate = undefined;
    this.inputTime = undefined;
  }

  inputChange() {
    if (Utilities.stringEmpty(this.inputTime) && Utilities.stringEmpty(this.inputDate)) {
      this.value = undefined;
      this.inputDate = undefined;
      this.inputTime = undefined;
    } else {

      // date/time could be selected out of order, so we may just have the time piece and no "Date"
      // but we can still set the selected time
      let workingDate = DateTime.local();
      if (this.inputDate) {
        workingDate = DateTime.fromISO(this.inputDate);
      }

      let workingTime = DateTime.local();
      if (this.inputTime) {
        workingTime = DateTime.fromISO(this.inputTime);
      } else if (this.type === 'date' && this.timeAnchor === TimeAnchor.EndOfDay) {
        workingTime = DateTime.fromISO('23:59:59');
      } else if (this.type === 'date' && this.timeAnchor === TimeAnchor.StartOfDay) {
        workingTime = DateTime.fromISO('00:00:00');
      } else if (this.type === 'date' && this.timeAnchor === TimeAnchor.MiddleOfDay) {
        workingTime = DateTime.fromISO('12:00:00');
      }

      // Combine the local date and time
      const combinedDateTime = workingDate.set({
        hour: workingTime.hour,
        minute: workingTime.minute,
      });

      // Update the display values (local time)
      if (this.inputDate) {
        // Convert combined local date/time to UTC for storage
        this.value = combinedDateTime.toUTC().toISO();
        this.inputDate = combinedDateTime.toFormat('yyyy-MM-dd'); // Local date
      }

      this.inputTime = combinedDateTime.toFormat("yyyy-MM-dd'T'HH:mm:ss"); // Local full ISO
    }
  }

  protected override updateValue(): void {
    this.initDateTimeValues();
  }

  private async initDateTimeValues() {
    if (this.value) {
      // Parse the UTC value using Luxon and convert to local time
      const localDateTime = DateTime.fromISO(this.value).toLocal();

      // Set inputDate and inputTime using local time values
      this.inputDate = localDateTime.toFormat('yyyy-MM-dd'); // Local date
      if (this.type === 'datetime' || this.type === 'time') {
        this.inputTime = localDateTime.toFormat("yyyy-MM-dd'T'HH:mm:ss"); // Local full ISO
      }
    } else {
      // // Default to tomorrow at the next 15-minute interval in local time
      // const defaultDate = DateTime.local().plus({ days: 1 }).startOf('minute').set({
      //   minute: Math.ceil(DateTime.local().minute / 15) * 15,
      // });

      // // Set default inputDate and inputTime
      // this.inputDate = defaultDate.toFormat('yyyy-MM-dd'); // Local date
      // this.inputTime = defaultDate.toFormat("yyyy-MM-dd'T'HH:mm:ss"); // Local full ISO
    }
  }

  private generateMinuteOptions() {
    if (this.minuteStep == 15) {
      return [0,15,30,45];
    }
    return null;
  }

}

export enum TimeAnchor {
  Now, // use the current time
  StartOfDay, // use the start of the day
  EndOfDay, // use the end of the day
  MiddleOfDay, // use the middle of the day
}